/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getTrustedBankAccounts = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Trusted Bank Account query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-trusted-bank-account-info/get?${queryString}`);
};

export const getTrustedBankAccountByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-trusted-bank-account-info/${id}`);
};

export const getTrustedBankAccountByMID = (mid) => {
  return API.get(`${getApiUrl()}/api/tkt1-trusted-bank-account-info/mid/${mid}`);
};

export const searchTrustedBankAccounts = (query) => {
  let queryString = '';
  
  if (query && Object.keys(query).length > 0) {
    queryString = '?' + Object.keys(query)
      .filter(key => query[key] !== undefined && query[key] !== null && query[key] !== '')
      .map(key => `${key}=${encodeURIComponent(query[key])}`)
      .join('&');
  }

  return API.get(`${getApiUrl()}/api/tkt1-trusted-bank-account-info/search${queryString}`);
};

export const createTrustedBankAccount = (accountData) => {
  return API.post(`${getApiUrl()}/api/tkt1-trusted-bank-account-info/`, accountData);
};

export const updateTrustedBankAccount = (id, accountData) => {
  return API.put(`${getApiUrl()}/api/tkt1-trusted-bank-account-info/${id}`, accountData);
};

export const deleteTrustedBankAccount = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-trusted-bank-account-info/${id}`);
};

export const tkt1TrustedBankAccountService = {
  getTrustedBankAccounts,
  getTrustedBankAccountByID,
  getTrustedBankAccountByMID,
  searchTrustedBankAccounts,
  createTrustedBankAccount,
  updateTrustedBankAccount,
  deleteTrustedBankAccount
};
